export const EmptySiteKey: string = '0';
